import script from "./OrderNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderNumber.vue?vue&type=script&setup=true&lang=ts"

import "./OrderNumber.vue?vue&type=style&index=0&id=440b608a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-440b608a"]])

export default __exports__